const R2_PUBLIC_URL = (process.env.VUE_APP_R2_PUBLIC_URL || "").replace(/\/$/, "");
const SUPABASE_URL = (
  process.env.VUE_APP_SUPABASE_URL || "https://vicdhqexnyeqwiokixup.supabase.co"
).replace(/\/$/, "");

function resolveApiBaseUrl() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "moldex.rennai.app" || host === "www.moldex.rennai.app") {
      return "https://moldex.api.rennai.app";
    }
    if (
      host === "moldexrealty-buyersportal.com" ||
      host === "www.moldexrealty-buyersportal.com"
    ) {
      return "https://api.moldexrealty-buyersportal.com";
    }
  }
  if (process.env.NODE_ENV === "development") {
    return (process.env.VUE_APP_SERVER_URL || "http://localhost:7002").replace(
      /\/$/,
      ""
    );
  }
  return (
    process.env.VUE_APP_PROD_SERVER_URL ||
    "https://api.moldexrealty-buyersportal.com"
  ).replace(/\/$/, "");
}

function extractFileName(attachmentPath) {
  const path = String(attachmentPath || "").trim();
  if (!path) return null;

  // Full URL (R2 / Supabase / other) → last path segment
  if (path.startsWith("http://") || path.startsWith("https://")) {
    try {
      const u = new URL(path);
      return u.pathname.split("/").filter(Boolean).pop() || null;
    } catch {
      return path.split("/").pop() || null;
    }
  }

  return path.split("/").pop() || null;
}

/**
 * Browser URL for a ticket attachment.
 * Serves via API proxy (/tickets/files/view/...) so clients whose Wi‑Fi
 * blocks Cloudflare *.r2.dev can still open PDFs on your own domain.
 */
export function getAttachmentPublicUrl(attachmentPath) {
  const fileName = extractFileName(attachmentPath);
  if (!fileName) return null;

  const apiBase = resolveApiBaseUrl();
  if (apiBase) {
    return `${apiBase}/tickets/files/view/${encodeURIComponent(fileName)}`;
  }

  // Fallbacks (local/dev without API base)
  if (R2_PUBLIC_URL) {
    return `${R2_PUBLIC_URL}/${fileName}`;
  }
  return `${SUPABASE_URL}/storage/v1/object/public/ticket-attachments/${fileName}`;
}
